<template>

    <v-modal title="Export Segment" :loading="starting">
        <template #body>
            <v-alert :message="error" />
            <div v-if="!success">
                <p>Are you sure you want to export:<br>{{ segment.name }}</p>
                <v-form-group dir="ver" label="Traits">
                    <v-select :model="all" @input="all = $event">
                        <option :value="true">Include all customer traits</option>
                        <option :value="false">Select customer traits</option>
                    </v-select>
                </v-form-group>
                <v-form-group v-if="!all" dir="ver">
                    <v-list grouped>
                        <v-list-item size="sm" v-for="t in traits" :key="t.id">
                            <div><span>{{ t.name }}</span></div>
                            <div>
                                <v-button v-if="params.fields.includes(t.field)" class="float-right" size="xs" btn-style="success" @click.native="toggleField(t.field)">Selected</v-button>
                                <v-button v-else class="float-right" size="xs" btn-style="secondary" @click.native="toggleField(t.field)">Select</v-button>
                            </div>
                        </v-list-item>
                    </v-list>
                </v-form-group>
            </div>
            <div v-else>
                <p>Your export is processing.<br>You can view all your segment exports on the <a href="#" @click.prevent="viewExports">Exports page</a>.</p>
            </div>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button v-if="!success" size="sm" btn-type="submit" :loading="loading" @click.native="exportSegment">Export Segment</v-button>
            <v-button v-else size="sm" @click.native="viewExports">View Exports</v-button>
        </template>
    </v-modal>

</template>

<script>

import ProjectApi from '@api/ProjectApi';
import SegmentApi from '@api/SegmentApi'

export default {

    props: {
        segment: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            starting: true,
            loading: false,
            success: false,
            error: null,
            all: true,
            traits: [],
            params: {
                fields: [],
            },
        }
    },

    mounted() {
        this.getTraits();
    },

    watch: {

        all(val) {
            if (!val) {
                this.params.fields = [];
            } else {
                this.params.fields = this.traits.map(t => t.field);
            }
        }

    },

    methods: {

        getTraits() {
            ProjectApi.getTraits(this.project.id)
                .then((response) => {
                    this.traits = response.data.data.sort((a, b) => {
                        return a.name.localeCompare(b.name)
                    });
                    this.params.fields = this.traits.map(t => t.field);
                    this.starting = false;
                }, (error) => {
                    this.error = error.response.data.message;
                    this.starting = false;
                });
        },

        exportSegment() {
            this.loading = true;
            SegmentApi.exportSegment(this.segment.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.success = true;
                    this.error = null;
                }, (error) => {
                    this.loading = false;
                    this.success = false;
                    this.error = error.response.data.message;
                });
        },

        viewExports() {
            this.$store.commit('showModal', false);
            this.$router.push({ name: 'exports' });
        },

        toggleField(field) {
            let index = this.params.fields.findIndex(f => f === field);
            if (index >= 0) {
                this.params.fields.splice(index, 1);
            } else {
                this.params.fields.push(field);
            }
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
